module.exports = __webpack_public_path__ + "img/riji.a8a38f6b.png";